import BaoCao from "./stores/BaoCao";
import DoanhNghiep from "./stores/DoanhNghiep";
import NhanVien from "./stores/NhanVien";
import NhomThe from "./stores/NhomThe";
import TheKiemSoat from "./stores/TheKiemSoat";
import CapThe from "./stores/CapThe";
import ManHinh from "./stores/ManHinh";
import KhaiBaoVe from "./stores/KhaiBaoVe";
export default {
    modules: {
        BaoCao,
        DoanhNghiep,
        NhanVien,
        NhomThe,
        TheKiemSoat,
        ManHinh,
        CapThe,
        KhaiBaoVe,
    },
};
